import { formatDateTime } from "../../helpers/dateFormat";

export const getQuoteV2 = (xml) => {
  try {
    const errMsgNode = xml.getElementsByTagName("errMsg")[0];
    if (errMsgNode) {
      return { error: errMsgNode.textContent };
    }

    const packageNodes = xml.getElementsByTagName("packageDetails");
    const packages = Array.from(packageNodes).map((pkg) => {
      const obtainedCvr = pkg.getElementsByTagName("obtainedCvr")[0]?.textContent || "";

      const coverageListItems = obtainedCvr
        .match(/[^,(]+(?:\([^)]*\))?[^,]*/g)
        ?.map(item => `<li>${item.trim()}</li>`) || [];

      const coverageList = `<ul>${coverageListItems.join("")}</ul>`;

      return {
        planId: pkg.getAttribute("id") || "N/A",
        plan: pkg.getElementsByTagName("planSelection")[0]?.textContent || "Standard Plan",
        premiumAmt: pkg.getElementsByTagName("premiumAmt")[0]?.textContent || "N/A",
        coverage: obtainedCvr || "N/A",
        coverageList
      };
    });
    // const packages = Array.from(packageNodes).map((pkg) => ({
    //   planId: pkg.getAttribute("id") || "N/A",
    //   plan: pkg.getElementsByTagName("planSelection")[0]?.textContent || "Standard Plan",
    //   premiumAmt: pkg.getElementsByTagName("premiumAmt")[0]?.textContent || "N/A",
    //   coverage: pkg.getElementsByTagName("obtainedCvr")[0]?.textContent || "N/A",
    // }));



    const prodIdNode = xml.getElementsByTagName("prodId")[0];
    const fullProdId = prodIdNode?.textContent || "";
    const prodId = fullProdId.split("-")[0].trim();

    return {
      carName: xml.getElementsByTagName("make")[0]?.textContent || "N/A",
      modelName: xml.getElementsByTagName("model")[0]?.textContent || "N/A",
      plateNumber: xml.getElementsByTagName("vehRegNo")[0]?.textContent || "N/A",
      plateCode: xml.getElementsByTagName("vehRegLOC")[0]?.textContent || "N/A",
      modelYear: xml.getElementsByTagName("modelYear")[0]?.textContent || "N/A",
      chassisNo: xml.getElementsByTagName("chasisNo")[0]?.textContent || "N/A",
      bodyType: xml.getElementsByTagName("vehBody")[0]?.textContent || "N/A",
      usageType: xml.getElementsByTagName("usage")[0]?.textContent || "N/A",
      vehicleValue: xml.getElementsByTagName("vehValue")[0]?.textContent || "N/A",
      insuredName: xml.getElementsByTagName("insureFullName")[0]?.textContent || "N/A",
      civilId: xml.getElementsByTagName("insuredLicNo")[0]?.textContent || "N/A",
      age: xml.getElementsByTagName("insuredAge")[0]?.textContent || "N/A",
      quoteNo: xml.getElementsByTagName("renewalQuoteNo")[0]?.textContent || "N/A",
      coverFromDate: formatDateTime(xml.getElementsByTagName("effectiveDt")[0]?.textContent || "N/A"),
      coverToDate: formatDateTime(xml.getElementsByTagName("expirationDt")[0]?.textContent || "N/A"),
      product: xml.getElementsByTagName("prodId")[0]?.textContent || "N/A",
      packages: packages,
      prodId: prodId,
      quoteStatus: xml.getElementsByTagName("quoteStatus")[0]?.textContent || "Quote",
      mobileNo: xml.getElementsByTagName("insuredMobileNo")[0]?.textContent || "",
      eMailId: xml.getElementsByTagName("insuredEmailId")[0]?.textContent || "",
      whatsappNo: "",
    };
  } catch (error) {
    console.error("Error extracting data:", error);
    return { error: "Unexpected response format" };
  }
};